import type { OutboundWebhookRead } from 'src/api/main'

/** `OutboundWebhook.managed_by` value Squad writes (contract C3). */
export const SQUAD_MANAGER = 'squad'

/** `instance_type.type` of the Squad application. */
export const SQUAD_APP_TYPE = 'squad'

const AGENT_REF =
  /^agent:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

type ManagedFields = {
  managed_by?: OutboundWebhookRead['managed_by']
  managed_ref?: OutboundWebhookRead['managed_ref']
}

export const isSquadManaged = (webhook: Pick<ManagedFields, 'managed_by'>) =>
  webhook.managed_by === SQUAD_MANAGER

/** The agent uuid from `agent:<uuid>`, or null for anything else. */
export const squadAgentIdFromRef = (managedRef?: string | null) =>
  AGENT_REF.exec(managedRef ?? '')?.[1] ?? null

/**
 * The agent page inside the workspace's Squad app, or null when the webhook is
 * not Squad's, Squad is not installed, or the ref is not an agent uuid.
 */
export const squadAgentUrl = (
  squadLaunchUrl: string | null,
  webhook: ManagedFields
): string | null => {
  if (!squadLaunchUrl || !isSquadManaged(webhook)) return null

  const agentId = squadAgentIdFromRef(webhook.managed_ref)

  return agentId
    ? `${squadLaunchUrl.replace(/\/+$/, '')}/agents/${agentId}`
    : null
}
